import { useState, useCallback } from 'react'
import { useNavigate } from 'react-router-dom'

import { DashboardLayout } from '../../components/layout/DashboardLayout'
import { Breadcrumb } from '../../components/ui/Breadcrumb'
import { shellAssets } from '../../constants/assets'
import { dashboardRoutes } from '../../constants/routes'

import { VehicleCategoryManager } from './components/vehicle-management/VehicleCategoryManager'
import { VehicleBrandManager } from './components/vehicle-management/VehicleBrandManager'

const currentUser = {
  name: 'Admin',
  email: 'Admin@123gmail.com',
  avatar: shellAssets.avatar,
}

type ManagementTab = 'categories' | 'brands'

const VehicleCategoriesBrandsPage = () => {
  const navigate = useNavigate()
    const [activeTab, setActiveTab] = useState<ManagementTab>('categories')
  
    const onBack = useCallback(
      () => navigate(dashboardRoutes.services),
      [navigate],
    )
    
  return (
    <DashboardLayout
      activeNavId="vehicle-management"
      contentGap={15}
      subtitle={
        <Breadcrumb
          items={[
            { label: 'Dashboard', path: dashboardRoutes.overview },
            { label: 'Services', path: dashboardRoutes.services },
            { label: 'Vehicle Categories & Brands' },
          ]}
        />
      }
      title="Vehicle Categories & Brands"
      user={currentUser}
    >
      <div className="flex min-h-0 flex-col gap-6 lg:h-[calc(100dvh-175px)] lg:overflow-hidden">
  {/* Fixed tabs and Back button */}
  <div className="flex shrink-0 flex-wrap items-center justify-between gap-4">
    <div className="flex w-fit items-center gap-2 rounded-[12px] border border-[#E0E0E0] bg-white p-1">
      <button
        type="button"
        onClick={() => setActiveTab('categories')}
        className={`rounded-[9px] px-5 py-2.5 font-host text-[14px] font-semibold transition-colors ${
          activeTab === 'categories'
            ? 'bg-[#334E1C] text-white'
            : 'text-[#555555] hover:bg-[#F5F5F5]'
        }`}
      >
        Vehicle Categories
      </button>

      <button
        type="button"
        onClick={() => setActiveTab('brands')}
        className={`rounded-[9px] px-5 py-2.5 font-host text-[14px] font-semibold transition-colors ${
          activeTab === 'brands'
            ? 'bg-[#334E1C] text-white'
            : 'text-[#555555] hover:bg-[#F5F5F5]'
        }`}
      >
        Vehicle Brands
      </button>
    </div>

    <button
      type="button"
      onClick={onBack}
      className="mr-[20px] font-host font-medium text-[#555555] hover:text-[#1A1A1A]"
    >
      ← Back to Services
    </button>
  </div>

  {/* Future category/brand rows scroll only here */}
  <div className="min-h-0 flex-1 pr-[4px] lg:overflow-y-auto lg:overscroll-contain">
    {activeTab === 'categories' ? (
      <VehicleCategoryManager />
    ) : (
      <VehicleBrandManager />
    )}
  </div>
</div>
    </DashboardLayout>
  )
}

export default VehicleCategoriesBrandsPage